import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        background: '#fff',
        minHeight: 50,
        borderBottom: '1px solid #ccc',
        borderRadius: 6,
        alignItems: 'center',
        padding: '0px 10px',
    },
    containerSelected: {
        backgroundColor: '#f0f7ff',
        borderBottom: '1px solid #cce0ff',
    },
    leftContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    radio: {
        display: 'flex',
        width: 18,
        height: 18,
        border: '2px solid #ccc',
        borderRadius: 9,
        justifyContent: 'center',
        alignItems: 'center',
    },
    radioSelected: {
        borderColor: '#0057b8',
    },
    radioDot: {
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor: '#0057b8',
    },
    centerContent: {
        justifyContent: 'center',
        flex: 1,
        padding: 10
    },
    rightContent: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: 10,
    },
    shippingTitle: {
        fontSize: 14,
        fontWeight: '600',
        color: '#333'
    },
    shippingTitleSelected: {
        color: '#0057b8',
    },
    shippingText: {
        fontSize: 12,
        color: '#888'
    },
    priceText: {
        fontSize: 15,
        fontWeight: 'bold',
        color: '#333'
    },
    priceTextSelected: {
        color: '#0057b8',
    },
    fakeCheckbox: {
        border: `1px solid #fff`,
        height: 15,
        width: 15,
        borderRadius: 2,
        justifyContent: 'center',
        alignItems: 'center'
    },
    icon: {
        fontSize: 20,
    }
}));

const ShippingCard = ({ data, colors, selectedOption, key, isCartScreen }) => {

    const classes = useStyles(colors);

    return (
        <div className={`${classes.container} ${selectedOption && isCartScreen ? classes.containerSelected : ''}`}>
            {isCartScreen && (
                <div className={`${classes.radio} ${selectedOption ? classes.radioSelected : ''}`} >
                    {selectedOption && <div className={classes.radioDot} />}
                </div>
            )}
            <div className={classes.centerContent}>
                <div className={`${classes.shippingTitle} ${selectedOption && isCartScreen ? classes.shippingTitleSelected : ''}`}>
                    {data.name}
                </div>
                <div className={classes.shippingText}>
                    {data.information}
                </div>
            </div>
            <div className={classes.rightContent}>
                <p className={`${classes.priceText} ${selectedOption && isCartScreen ? classes.priceTextSelected : ''}`}>
                    {data.displayPrice}
                </p>
            </div>
        </div>
    )
}

export default ShippingCard;